export default __webpack_public_path__ + "static/media/cazatrabajo.7eb9a92b.svg";